// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HzCard_wrapper__IfmI3"};